import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

// local dependencies
import { timeElapsed as calculateTimeElapsed } from 'utils/time';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callTimer as CallTimer } from 'ui/views/generic/callTimer';
 *
 * // render
 * <CallTimer propName='propValue'/>
 */
export const callTimer = ( props ) => {

    // calculate time elapsed every second
    const [ timeElapsed, setTimeElapsed ] = useState( calculateTimeElapsed( props.startTime, props.endTime ) );
    const [ intervalId, setIntervalId ] = useState();
    
    useEffect( () => {

        // create existing interval
        clearInterval( intervalId );

        // if - `endTime` is provided, only update elapsed duration
        // else - start a new timer
        if( ! isEmpty( props.endTime ) ) {
            setTimeElapsed( calculateTimeElapsed( props.startTime, props.endTime ) );
        } else {

            // set new interval
            const _intervalId = setInterval( () => {
                setTimeElapsed( calculateTimeElapsed( props.startTime ) );
            }, 1000 );

            // update timer id and cancel on unmount
            setIntervalId( _intervalId );
            return () => clearInterval( _intervalId );
        }

       
    }, [ props.startTime, props.endTime ] );

    // dynamic widget class name
    const widgetClassName = classnames( 'ui-call-timer', props.className );

    return (
        <div className={ widgetClassName }>
            { timeElapsed }
        </div>
    );
};

// set display name
callTimer.displayName = 'callTimer';

// set default props
callTimer.defaultProps = {
    startTime: ( new Date() ).toISOString(), // ISO string
    endTime: null, // ISO string
};

// prop types
callTimer.propTypes = {};
